import { StyleSheet, View } from 'react-native';

import { Pill, Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type StatCardProps = {
  label: string;
  value: string;
  delta?: string;
  hint?: string;
  accent?: 'wine' | 'ember' | 'verde' | 'gold' | 'plain';
};

export function StatCard({ label, value, delta, hint, accent = 'plain' }: StatCardProps) {
  const theme = useTheme();
  return (
    <View
      style={[
        styles.card,
        { backgroundColor: theme.colors.bgSoft, borderRadius: theme.radii.md, borderColor: theme.colors.rule },
      ]}
    >
      <View style={styles.head}>
        <Text variant="eyebrow" tone="fgMute">{label}</Text>
        {delta ? <Pill variant={accent === 'plain' ? 'ghost' : (accent as any)}>{delta}</Pill> : null}
      </View>
      <Text
        style={{
          fontFamily: theme.fontFamily.displayItalic,
          fontStyle: 'italic',
          fontSize: 56,
          lineHeight: 60,
          color: theme.colors.fg,
          marginTop: 8,
        }}
      >
        {value}
      </Text>
      {hint ? (
        <Text variant="meta" tone="fgMute" style={{ marginTop: 8 }}>
          {hint}
        </Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flex: 1,
    minWidth: 220,
    padding: 24,
    borderWidth: 1,
  },
  head: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
});
